<template>
  <div class="y_payments_user">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        已开通账期
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting(1)">刷新</div>
        </div>
      </div>
    </div>

    <div class="content_box" v-if="role">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="export_box">
            <el-button type="primary" size="small" @click="export_payments_user()">导出列表</el-button>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <div class="table">
        <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
          <el-table-column prop="mobile" width="150" label="账号" align="center"></el-table-column>
          <el-table-column prop="bind_mobile" width="120" label="绑定手机号" align="center"></el-table-column>
          <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
          <el-table-column prop="create_date" width="170" label="注册时间" align="center"></el-table-column>
          <el-table-column label="消费金额" align="center" prop="pay_sum_money"></el-table-column>
          <el-table-column label="操作" width="180" align="center" name="bianji">
            <template slot-scope="scope" style="display:flex;padding:0;margin:0">
              <router-link target="_blank" :to="'/admin/y_userLook/'+scope.row.mobile+'/1'">
                <button class="button1">查看详情</button>
              </router-link>
              <button @click="close_payments(scope.row.mobile)" class="button1">关闭账期支付</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_box clearfix">
        <div class="page">
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page.sync="page"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>
<script>
import "../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      token: "",
      username: "",
      page: 1,
      total: 0,
      tableData: []
    };
  },
  created() {
    this.$store.state.leftTitle = "账期列表";
    this.$store.state.topActiveId = 4;
    this.geting();
  },
  watch: {},
  methods: {
    export_payments_user() {
      this.$message({
        message: "excel导出成功",
        type: "success",
        offset: 200
      });
      window.location.href = this.serve + "/excel/export_payments_user";
    },
    close_payments(mobile) {
      var where = {
        username: this.username,
        token: this.token,
        mobile: mobile
      };
      this.axios
        .get(this.serve + "/admin/open_close_payment", {
          params: where
        })
        .then(res => {
          if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }else{
            this.geting(this.page);
          }
        });
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .get(this.serve + "/admin/payment_user_list", {
          params: {
            token: this.token,
            username: this.username,
            page: page
          }
        })
        .then(res => {
          loading.close();
          that.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            this.total = json.total;
            this.page = Number(json.page);
            for (var key in json.results) {
              this.tableData.push(json.results[key]);
              var time = json.results[key].create_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].create_date = timeNew;
            }
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.y_payments_user {
  .export_box {
    margin-right: 20px;
  }
  .pager {
    height: 30px;
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>